import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestHelper } from '@shared/helpers/request.helper';
import { PaginationRequest } from './models/pagination/pagination.request.model';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root'
})
export class TeacherApiService {
    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}`;
    }

    // Teachers
    getTeachers(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/teachers`, { params: options });
    }

    createTeacher(data: any): Observable<any> {
        return this.http.post(`${this.url}/teachers`, data);
    }

    updateTeacher(data: any): Observable<any> {
        return this.http.put(`${this.url}/teachers`, data);
    }

    // Teacher Cluster History
    getTeacherClusterHistories(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/teacher-cluster-histories`, { params: options });
    }

    createTeacherClusterHistory(data: any): Observable<any> {
        return this.http.post(`${this.url}/teacher-cluster-histories`, data);
    }

    updateTeacherClusterHistory(data: any): Observable<any> {
        return this.http.put(`${this.url}/teacher-cluster-histories`, data);
    }

    // Teacher Shift History
    getTeacherShiftHistories(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/teacher-shift-histories`, { params: options });
    }

    createTeacherShiftHistory(data: any): Observable<any> {
        return this.http.post(`${this.url}/teacher-shift-histories`, data);
    }

    updateTeacherShiftHistory(data: any): Observable<any> {
        return this.http.put(`${this.url}/teacher-shift-histories`, data);
    }

    // Teacher Min-Max History
    getTeacherMinmaxHistories(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/teacher-minmax-histories`, { params: options });
    }

    createTeacherMinmaxHistory(data: any): Observable<any> {
        return this.http.post(`${this.url}/teacher-minmax-histories`, data);
    }

    updateTeacherMinmaxHistory(data: any): Observable<any> {
        return this.http.put(`${this.url}/teacher-minmax-histories`, data);
    }

    // Teacher Levels (already exists in backend)
    getTeacherLevels(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.http.get(`${this.url}/teacher-levels`, { params: options });
    }

    createTeacherLevel(data: any): Observable<any> {
        return this.http.post(`${this.url}/teacher-levels`, data);
    }

    updateTeacherLevel(data: any): Observable<any> {
        return this.http.put(`${this.url}/teacher-levels`, data);
    }
}
